import React, {createContext, useReducer, useEffect} from "react";
import AppReducer from "./AppReducer";

// initial state
const initialState = {
    movieWatchlist: localStorage.getItem("watchlist") ? JSON.parse(localStorage.getItem("watchlist")) : [],
    movieWatched: localStorage.getItem("watched") ? JSON.parse(localStorage.getItem("watched")) : [],
    serieWatchlist: localStorage.getItem("serieWatchlist") ? JSON.parse(localStorage.getItem("serieWatchlist")) : [],
    serieWatched: localStorage.getItem("serieWatched") ? JSON.parse(localStorage.getItem("serieWatched")) : [],
    bookReadlist: localStorage.getItem("bookshelf") ? JSON.parse(localStorage.getItem("bookshelf")) : [],
    bookRead: localStorage.getItem("read") ? JSON.parse(localStorage.getItem("read")) : [],
    loggedIn : localStorage.getItem("loggedIn") ? localStorage.getItem("loggedIn") : false
};

// create context
export const GlobalContext = createContext(initialState);

// provider
export const GlobalProvider = (props) => {
    const [state, dispatch] = useReducer(AppReducer, initialState);

    useEffect(() => {
        localStorage.setItem("watchlist", JSON.stringify(state.movieWatchlist))
        localStorage.setItem("watched", JSON.stringify(state.movieWatched))
        localStorage.setItem("serieWatchlist", JSON.stringify(state.serieWatchlist))
        localStorage.setItem("serieWatched", JSON.stringify(state.serieWatched))
        localStorage.setItem("bookshelf", JSON.stringify(state.bookReadlist))
        localStorage.setItem("read", JSON.stringify(state.bookRead))
        localStorage.setItem("loggedIn", state.loggedIn)
    }, [state])

    //actions
    const addMovieToWatchlist = (movie) => {
        dispatch({type: "ADD_MOVIE_TO_WATCHLIST", payload: movie})
    }

    const removeMovieFromWatchlist = (id) => {
        dispatch({type: "REMOVE_MOVIE_FROM_WATCHLIST", payload: id})
    }

    const addMovieToDone = (movie) => {
        dispatch({type: "ADD_MOVIE_TO_DONE", payload: movie})
    }

    const removeMovieFromDone = (id) => {
        dispatch({type: "REMOVE_MOVIE_FROM_DONE", payload: id})
    }

    const addSerieToWatchlist = (serie) => {
        dispatch({type: "ADD_SERIE_TO_WATCHLIST", payload: serie})
    }

    const removeSerieFromWatchlist = (id) => {
        dispatch({type: "REMOVE_SERIE_FROM_WATCHLIST", payload: id})
    }

    const addSerieToDone = (serie) => {
        dispatch({type: "ADD_SERIE_TO_DONE", payload: serie})
    }

    const removeSerieFromDone = (id) => {
        dispatch({type: "REMOVE_SERIE_FROM_DONE", payload: id})
    }

    const addBookToBookshelf = (book) => {
        dispatch({type: "ADD_BOOK_TO_BOOKSHELF", payload: book})
    }

    const removeBookFromBookshelf = (id) => {
        dispatch({type: "REMOVE_BOOK_FROM_BOOKSHELF", payload: id})
    }

    const addBookToDone = (book) => {
        dispatch({type: "ADD_BOOK_TO_DONE", payload: book})
    }

    const removeBookFromDone = (id) => {
        dispatch({type: "REMOVE_BOOK_FROM_DONE", payload: id})
    }

    return (
        <GlobalContext.Provider value={
            {movieWatchlist: state.movieWatchlist,
             movieWatched: state.movieWatched,
             serieWatchlist: state.serieWatchlist,
             serieWatched: state.serieWatched,
             bookReadlist:state.bookReadlist,
             bookRead: state.bookRead,
             loggedIn: state.loggedIn,
             addMovieToWatchlist: addMovieToWatchlist,
             addSerieToWatchlist: addSerieToWatchlist,
             addBookToBookshelf: addBookToBookshelf,
             removeMovieFromWatchlist: removeMovieFromWatchlist,
             removeSerieFromWatchlist: removeSerieFromWatchlist,
             removeBookFromBookshelf: removeBookFromBookshelf,
             addMovieToDone: addMovieToDone,
             addSerieToDone: addSerieToDone,
             addBookToDone: addBookToDone,
             removeBookFromDone: removeBookFromDone,
             removeMovieFromDone: removeMovieFromDone,
             removeSerieFromDone: removeSerieFromDone
             }}>
            {props.children}
        </GlobalContext.Provider>
    );
};